import PieChartWidget from './pieChartWidget'
import { checkIfAllEmpty, getFormattedProcessesData } from './utils'
import {
  ACTION_FETCH_PROCESS_BASED_ON_GROUPS,
  ProcessGroupCount,
  fetchProcessBasedOnGroups
} from '../privacyOpsOverviewSlice'
import { RootState } from '../../../rootReducer'
import { getShowLoader } from '../../../reducers/requestReducer'
import { getUpdatedUrl } from '../../../utils/urlUtil'
import {
  PAGE_VIEW_KEY,
  PAGE_VIEW_VALUES,
  URL_DEFINED_PROCESSES,
  URL_ROPA
} from '../../../constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect, useMemo } from 'react'
import { Typography } from '@lightbeamai/design-system'

const MAP_PROCESS_GROUP_TO_COLORS = [
  '#2899E0',
  '#723DFD',
  '#00A198',
  '#2E55E5',
  '#F4BF20',
  '#737D93'
]
interface IProps {
  processBasedOnGroups: ProcessGroupCount[]
  totalRopaProcesses: number
  timePeriod?: string
  showLoader: boolean
  fetchProcessBasedOnGroups: (timePeriod: string) => void
}

const ProcessesBasedOnGroupsWidget = ({
  processBasedOnGroups,
  totalRopaProcesses,
  timePeriod = '',
  showLoader,
  fetchProcessBasedOnGroups
}: IProps) => {
  const intl = useIntl()

  useEffect(() => {
    fetchProcessBasedOnGroups(timePeriod)
  }, [fetchProcessBasedOnGroups, timePeriod])

  const formattedData = useMemo(
    () =>
      getFormattedProcessesData(
        processBasedOnGroups,
        totalRopaProcesses,
        URL_ROPA,
        intl,
        MAP_PROCESS_GROUP_TO_COLORS
      ),
    [processBasedOnGroups, totalRopaProcesses, intl]
  )

  return (
    <PieChartWidget
      title={intl.formatMessage({ id: 'po.dashboard.processBasedOnGroups.widget.title' })}
      help={
        <>
          {intl.formatMessage({ id: 'po.dashboard.processBasedOnGroups.widget.helpText' })}
          <Typography variant={'baseMinus4'} color="secondary" as="i" className="block font-italic">
            {intl.formatMessage({ id: 'po.dashboard.processBasedOnGroups.widget.infoText' })}
          </Typography>
        </>
      }
      data={checkIfAllEmpty(formattedData)}
      legendPosition="right"
      showLoader={showLoader}
      viewAllBtnText={intl.formatMessage({
        id: 'po.dashboard.processBasedOnGroups.widget.viewAllBtn'
      })}
      viewAllLink={getUpdatedUrl({
        pathName: `${URL_ROPA}${URL_DEFINED_PROCESSES}`,
        pageName: URL_DEFINED_PROCESSES,
        pageQueryParams: {
          [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list
        }
      })}
    />
  )
}

const mapStateToProps = (state: RootState) => ({
  processBasedOnGroups: state.privacyOpsOverview.processBasedOnGroups,
  totalRopaProcesses: state.privacyOpsOverview.totalRopaProcesses,
  timePeriod: state.customDashboards.filterProps.timePeriod,
  showLoader: getShowLoader(ACTION_FETCH_PROCESS_BASED_ON_GROUPS)
})

const mapDispatchToProps = {
  fetchProcessBasedOnGroups
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessesBasedOnGroupsWidget)
